export default __webpack_public_path__ + "img/auth-arrow.c5b7ee8c.svg";